'use strict';

const {initOpenApp} = require('./open-app');
document.querySelectorAll('.js-app-open').forEach(element => initOpenApp(element));


let slideshowBlock
let allSlideshow = document.querySelectorAll('.js-slideshow');

if (allSlideshow.length > 0) {
  import(/* webpackChunkName: "slideshow" */ './slideshow').then(function(module) {
    slideshowBlock = module.default || module;

    for (let i = 0; i < allSlideshow.length; i++) {
      slideshowBlock(allSlideshow[i]);
    }
  });
}
